var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9095 11.6875L12.375 3.15305C12.2478 3.02482 12.0963 2.92315 11.9295 2.85396C11.7626 2.78476 11.5837 2.74943 11.4031 2.75001H3.43751C3.25517 2.75001 3.0803 2.82244 2.95137 2.95137C2.82244 3.0803 2.75001 3.25517 2.75001 3.43751V11.4031C2.74943 11.5837 2.78476 11.7626 2.85396 11.9295C2.92315 12.0963 3.02482 12.2478 3.15305 12.375L11.6875 20.9095C11.8152 21.0372 11.9668 21.1385 12.1336 21.2076C12.3005 21.2767 12.4793 21.3123 12.6599 21.3123C12.8405 21.3123 13.0193 21.2767 13.1862 21.2076C13.353 21.1385 13.5046 21.0372 13.6323 20.9095L20.9095 13.6323C21.0372 13.5046 21.1385 13.353 21.2076 13.1862C21.2767 13.0193 21.3123 12.8405 21.3123 12.6599C21.3123 12.4793 21.2767 12.3005 21.2076 12.1336C21.1385 11.9668 21.0372 11.8152 20.9095 11.6875ZM12.6595 19.9375L4.12501 11.4031V4.12501H11.4031L19.9375 12.6595L12.6595 19.9375ZM8.25001 7.21876C8.25001 7.42272 8.18953 7.6221 8.07621 7.79169C7.96289 7.96128 7.80184 8.09345 7.6134 8.17151C7.42496 8.24956 7.21761 8.26998 7.01757 8.23019C6.81753 8.1904 6.63378 8.09218 6.48955 7.94796C6.34533 7.80374 6.24711 7.61999 6.20732 7.41994C6.16753 7.2199 6.18795 7.01255 6.26601 6.82411C6.34406 6.63568 6.47624 6.47462 6.64583 6.3613C6.81541 6.24799 7.01479 6.18751 7.21876 6.18751C7.49226 6.18751 7.75456 6.29616 7.94796 6.48955C8.14136 6.68295 8.25001 6.94525 8.25001 7.21876Z",
    fill: "#969696"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.2443a61055cc89ae022166a4631ccc6f.svg";
export { ForwardRef as ReactComponent };